<template lang="pug"></template>

<script>
import toastr from 'toastr'
import { trackAnalyticsEvent } from '../../utils/analytics.js'

export default {
  name: 'Notification',

  data () {
    return {
      toastr: toastr,
      options: {
        'closeButton': true,
        'debug': false,
        'newestOnTop': true,
        'progressBar': true,
        'positionClass': 'toast-top-right',
        'preventDuplicates': true,
        'onclick': null,
        'showDuration': '300',
        'hideDuration': '1000',
        'timeOut': '5000',
        'extendedTimeOut': '2000',
        'showEasing': 'swing',
        'hideEasing': 'linear',
        'showMethod': 'fadeIn',
        'hideMethod': 'fadeOut'
      }
    }
  },

  methods: {
    remove () {
      this.toastr.remove()
    },
    clear () {
      this.toastr.clear()
    },
    success (message, title) {
      trackAnalyticsEvent(this, 'notification', 'success', this.translate(message))
      this.toastr.success(this.translate(message), this.translate(title))
    },
    info (message, title) {
      trackAnalyticsEvent(this, 'notification', 'info', this.translate(message))
      this.toastr.info(this.translate(message), this.translate(title))
    },
    warning (message, title) {
      trackAnalyticsEvent(this, 'notification', 'warning', this.translate(message))
      this.toastr.warning(this.translate(message), this.translate(title))
    },
    error (message, title) {
      trackAnalyticsEvent(this, 'notification', 'error', this.translate(message))
      this.toastr.error(this.translate(message), this.translate(title))
    },
    // Permitira maior flexibilidade com as mensagens,
    // não ficando preso ao translate interno do componente
    global (type, message, title) {
      switch (type) {
        case 'S':
          this.toastr.success(message, title)
          break
        case 'I':
          this.toastr.info(message, title)
          break
        case 'W':
          this.toastr.warning(message, title)
          break
        case 'E':
          this.toastr.error(message, title)
          break
      }
    },
    translate (key) {
      return this.$t(key)
    }
  },

  created () {
    this.toastr.options = this.options
  }
}
</script>

<style>
#toast-container {
  font-family: 'Inter', sans-serif;
}

#toast-container>.toast-success {
  background-color: #72b372;
}

#toast-container>.toast-info {
  background-color: #56a9c1;
}

#toast-container>.toast-warning {
  background-color: #f7ae45;
}

#toast-container>.toast-error {
  background-color: #c65b55;
}

#toast-container>div {
  opacity: 0.95 !important;
  padding: 20px 20px 20px 55px !important;
}

.toast-close-button {
  top: -0.6em !important;
}
</style>



// WEBPACK FOOTER //
// Notification.vue?12e3848f